export const NAVIGATION = 'NAVIGATION';
export const REDIRECTION = 'REDIRECTION';
export const INITIALIZATION_ERROR = 'INITIALIZATION_ERROR';